import Column from '@components/Column';
import Loading from '@components/Loading';
import styled from '@emotion/styled';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import Amount from './components/Amount';
import Etc from './components/Etc';
import Items from './components/Items';
import ReceiptHeader from './components/ReceiptHeader';
import ShopInfo from './components/ShopInfo';
import useOrderReceipt from './hooks/useOrderReceipt';

interface Params {
    orderId: string;
}

declare module '@stackflow/config' {
    interface Register {
        OrderReceiptActivity: Params;
    }
}

const OrderReceiptActivity: ActivityComponentType<'OrderReceiptActivity'> = ({ params }) => {
    const { orderId } = params;
    const { receipt, isLoading } = useOrderReceipt(orderId);
    return (
        <AppScreen>
            <ReceiptHeader/>
            {isLoading && (
                <Loading />
            )}
            {receipt && (
                <Container as='main'
                    fullWidth>
                    <ShopInfo receipt={receipt}/>
                    <Items receipt={receipt}/>
                    <Amount receipt={receipt}/>
                    <Etc receipt={receipt}/>
                </Container>
            )}
        </AppScreen>
    );
};

const Container = styled(Column)`
    padding: 36px 20px 120px;

    span, p, h2 {
        color: var(--color-gray8);
    }
`;

export default OrderReceiptActivity;
